import { createActionTypes } from "../../helpers/utils/createActionTypes";

export const WORKFLOW = {
    PUT_WORKFLOW_CHANGE_STATUS: createActionTypes("PUT_WORKFLOW_CHANGE_STATUS"),
    CLEAN_MESSAGE_WORKFLOW: "CLEAN_MESSAGE_WORKFLOW",
};